module.exports = __webpack_public_path__ + "static/thpcblueeleph3-d1f9759531731ef15854708e300ec75b.jpeg";